import Api from "../api";

import { User, Role } from "./models.jsx";

const rolesUrl = "roles"
const roleUrl = "role"

class UserApi extends Api {

	getPage(startItem, endItem, keyword, sort, callback) {

	    var url = this.baseUrl;

	    this.client.get(url, { 
	    	headers: {"Range": "items=" + startItem + "-" + endItem},
	    	params: { sort: sort, keyword: keyword }
	    }).then((response) => {
			var rangeHeader = response.headers["range"];
			var total = parseInt(rangeHeader.split("/")[1]);

			var data = [];
			for (var index = 0; index < response.data.length; index++) {
				data.push(new User(response.data[index]));
			}

	    	callback({ 
	    		result: { data: data, total: total }, 
	    		error: null
	    	});
	    }).catch((error) => {
	    	callback({ 
	    		result: null, 
	    		error: this.extractError(error)
	    	});
	    });
	    
	}

	get(userId, callback) {
    	var url = this.baseUrl + userId;

	    this.client.get(url).then((response) => {
	    	callback({ 
	    		result: new User(response.data),
	    		error: null
	    	});
	    }).catch((error) => {
	    	callback({ 
	    		result: null, 
	    		error: this.extractError(error)
	    	});
	    });
	}

	addRole(userId, roleId, callback) {
    	var url = this.baseUrl + userId + "/" + roleUrl;

	    this.client.post(url, roleId, {
	    	headers: { "Content-Type": "application/json" }
	    }).then((response) => {
	    	callback({ 
	    		result: new User(response.data),
	    		error: null
	    	});
	    }).catch((error) => {
	    	callback({ 
	    		result: null, 
	    		error: this.extractError(error)
	    	});
	    });
	}

	removeRole(userId, roleId, callback) {
    	var url = this.baseUrl + userId + "/" + roleUrl;

	    this.client.delete(url, {
	    	headers: { "Content-Type": "application/json" },
	    	data: roleId
	    }).then((response) => {
	    	callback({ 
	    		result: new User(response.data),
	    		error: null
	    	});
	    }).catch((error) => {
	    	callback({ 
	    		result: null, 
	    		error: this.extractError(error)
	    	});
	    });
	}

}

class RolesApi extends Api {

	get(mainRole, assignable, callback) {
    	var url = this.baseUrl;

	    this.client.get(url, {
	    	params: { mainRole: mainRole, assignable: assignable }
	    }).then((response) => {

	    	var data = [];
			for (var index = 0; index < response.data.length; index++) {
				data.push(new Role(response.data[index]));
			}

	    	callback({ 
	    		result: data,
	    		error: null
	    	});
	    }).catch((error) => {
	    	callback({ 
	    		result: null, 
	    		error: this.extractError(error)
	    	});
	    });
	}
}


class UsersApi{

	constructor(baseUrl) {
		this.users = new UserApi(baseUrl);
		this.roles = new RolesApi(baseUrl + rolesUrl);
	}

}

export default UsersApi;